{
  "test": "Тестове повідомлення",
  "email_subscribe_header": "Дізнайтеся першим",
  "email": "Електронна пошта",
  "password": "Пароль",
  "recovery": "Відновлення паролю",
  "recovery_subtitle": "Код підтвердження надіслано на адресу",
  "recovery_code": "Введіть код",
  "forgot_pass": "Забули свій пароль?",
  "pass": "Введіть ваш пароль",
  "pass_subtitle": "Ви ввімкнули двоетапну перевірку. ",
  "your_email": "Ваша електронна адреса",
  "your_password": "Ваш пароль",
  "subscribe": "Підпишіться",
  "rights": "© 2024 CardBook. All rights reserved.",
  "terms": "Правила",
  "privacy": "Політика",
  "quick_links": "Швидкі посилання",
  "news": "Новини",
  "packages": "Пакети",
  "about_us": "Про нас",
  "how_it_works": "Як це працює",
  "main_functions": "Основні функції",
  "contacts": "Контакти",
  "sign_in": "Увійти",
  "create_account": "Створити аккаунт",
  "next": "Далі",
  "back": "Назад",
  "confirm": "Підтвердити",
  "send": "Надіслати",
  "resend_code": "Надіслати код знову",
  "resend": "Надіслати код",
  "invalid_code": "Невірний код",
  "terms_accept_checkbox": "Я прочитав(ла) і приймаю Правила та умови і Політику конфіденційності",
  "terms_accept_required": "Прийміть Правила та умови і Політику конфіденційності, щоб продовжити",
  "terms_updated_title": "Наші Правила та Політика конфіденційності оновлені",
  "terms_updated_body": "Ознайомтеся з оновленими документами та прийміть їх, щоб продовжити користуватися CardBook.",
  "terms_updated_on": "Останнє оновлення: {date}",
  "terms_accept_button": "Прийняти та продовжити",
  "country": "Країна",
  "sign_in_to": "Увійдіть в CardBook",
  "sign_up_to": "Зареєструватися в CardBook",
  "keep_me_signed_in": "Залишати мене в обліковому записі",
  "sign_in_subtitle": "Щоб увійти, підтвердьте свою країну та введіть свій номер телефону.",
  "email_sign_in_subtitle": "Щоб увійти, введіть свою електронну пошту або продовжіть з номером телефону",
  "sign_in_by_email": "Увійти за електронною поштою",
  "sign_in_by_phone": "Увійти за номером телефону",
  "pin_subtitle": "Ми надіслали код на перевірений телефон.",
  "pin_email_subtitle": "Ми надіслали код на вказану електронну пошту",
  "didnt_receive_code": "Не отримали код?",
  "sign_in_with_email": "Увійти через email",
  "no_code_hint": "Код може не надійти через обмеження оператора або країни. Ми працюємо над вирішенням і скоро усунемо цю проблему.",
  "set_new_password": "Встановити новий пароль",
  "set_new_password_subtitle": "Будь ласка, створіть новий пароль для вашого облікового запису",
  "link_email": "Прив'язати email",
  "link_email_subtitle": "Це необхідно для скидання пароля, активації та входу в акаунт",
  "registration_subtitle": "Ми помітили, що ви з нами вперше! ",
  "reg_agreement": "Реєструючись, ви погоджуєтеся з <a style='color: #4497B0; text-decoration: underline;' href='{terms}' target='_blank' rel='noopener'>Правила та умови</a> і <a style='color: #4497B0; text-decoration: underline;' href='{privacy}' target='_blank' rel='noopener'>Політика конфіденційності</a>, включаючи <a style='color: #4497B0; text-decoration: underline;' href='{cookie}' target='_blank' rel='noopener'>Політика використання файлів cookie</a>.",
  "first_name": "Ім'я",
  "last_name": "Прізвище",
  "my_profile": "Мій профіль",
  "my_cabinet": "Мій кабінет",
  "settings": "Налаштування",
  "log_out": "Вийти з профілю",
  "overview": "Головна",
  "search": "Пошук",
  "digital_bank": "Digital Bank",
  "chat": "Чат",
  "connector": "Connector",
  "info_hub": "InfoHub",
  "subscriptions": "Підписки",
  "support": "Підтримка",
  "help": "Довідка",
  "terms_tool": "Терміни",
  "privacy_tool": "Конфіденційність",
  "more": "Ще",
  "log_out_": "Вийти",
  "begin": "Почніть",
  "phone": "Номер телефону",
  "curr_detail": "Введіть свої поточні дані. Додайте фотографію і заповніть актуальну інформацію. Це важливий пункт, завдяки якому будь-який користувач, зайшовши у ваш профіль, зможе впізнати вас і зрозуміти, чим ви займаєтеся.",
  "edit_profile_text": "Тепер ваш профіль заповнений. Наявність фотографії у профілі дуже важлива, тому що вона допомагає користувачам зрозуміти, хто ви і чим займаєтеся. Постійно оновлюйте інформацію, щоб отримувати кращі результати від нетворкінгу.",
  "find_friend": "Знайдіть своїх друзів на платформі або завантажте їхні візитні картки і збережіть у Digital Bank. Ми рекомендуємо одразу відсортувати їх і вказати рівень доступу до контакту. (Детальніше про рівні доступу в CardBook можна дізнатися",
  "find_friend_link": "тут)",
  "search_section": "Завітайте до розділу «Пошук» — саме тут відображатиметься ваша візитна картка після заповнення профілю. Це нескінченна стрічка цінних контактів і людей, з якими ви можете зв'язатися на CardBook.",
  "might_be": "Може бути корисним",
  "useful_video": "Корисне відео",
  "fresh_events": "Свіжі події",
  "validation_required": "Поле обов'язкове.",
  "validation_email": "Введіть дійсну адресу електронної пошти.",
  "validation_url": "Введіть дійсну URL-адресу",
  "validation_password": "Пароль має містити принаймні вісім символів, принаймні одну цифру, одну велику та одну малу літеру.",
  "validation_password_confirm": "Паролі мають збігатися.",
  "validation_min": "{field} має містити принаймні {n} символів.",
  "validation_max": "Максимальна дозволена довжина поля {field} становить {n}.",
  "validation_birth": "Введіть правильну дату.",
  "validation_phone": "Введіть дійсний номер телефону.",
   "validation_min_phone": "Телефон має містити принаймні 10 символів.",
  "validation_max_phone": "Максимальна дозволена довжина поля телефон становить 14.",
  "error": "Помилка",
  "mail_exist": "Ця електронна адреса вже використовувалася",
  "error_login": "Не той телефон.",
  "error_pass": "Неправильний пароль.",
  "error_pin": "Неправильний пін-код.",
  "error_registration": "Помилка реєстрації.",
  "error_update_user": "Помилка оновлення даних користувача.",
  "error_server": "Помилка сервера.",
  "error_occurred": "Виникла помилка.",
  "translation_failed": "Не вдалося перекласти. Показано оригінальний текст.",
  "error_update_image": "Помилка завантаження зображення.",
  "complete_profile": "Заповніть свій профіль",
  "add_card": "Додайте візитну картку",
  "expand": "Розширюйте мережу контактів",
  "btn_fill": "Заповніть профіль",
  "visit_secret": "Відвідайте Пошук",
  "welcome": "Ласкаво просимо!",
  "welcome_banner": "Ласкаво просимо",
  "joined": "Ви приєдналися до CardBook",
  "text_modal": "CardBook — це платформа, де у вас є безмежні можливості! ",
  "edit": "Відредагуйте свій профіль",
  "processing": "Обробка..",
  "not_found": "Сторінку не знайдено",
  "not_found_text": "Вибачте, але нам не вдалося знайти потрібну сторінку. ",
  "home": "додому",
  "cardMarket": "CardMarket",
  "remaining": "Залишилося",
  "add_new_contact": "Додати новий контакт",
  "name": "Ім'я",
  "surname": "Прізвище",
  "competence": "Компетентність",
  "profile_miss": "У профілі відсутня інформація",
  "attention_modal": "Якщо ви хочете додати вміст, ви повинні заповнити всі деталі у своєму особистому профілі.",
  "later": "Пізніше",
  "fill_btn": "Заповніть профіль",
  "no_email": "Немає пов’язаних електронних адрес",
  "no_email_text": "Якщо ви хочете додати вміст, ви повинні зв’язати свою електронну адресу.",
  "add_email": "Додати електронну пошту",
  "add": "Додати",
  "no_matches": "На платформі не знайдено збігів для вказаних даних",
  "add_text": "Якщо потрібної людини немає в списку",
  "positioning": "Рід діяльності",
  "city": "Місто",
  "direction": "Напрямок",
  "talk_language": "Мова спілкування",
  "price_for_access": "Ціна за доступ",
  "write_text": "Напишіть текст підказки",
  "Newbie": "Новачок",
  "Skilled": "Досвідчений",
  "Expert": "Експерт",
  "edit_cover": "Редагувати фото",
  "edit_profile": "Редагувати профіль",
  "remove_cover": "Видалити фото",
  "select_cover": "Оновити фото",
  "about_me": "Про мене",
  "industries": "Індустрії",
  "directions": "Напрямки",
  "competences": "Компетенції",
  "expertise": "Рівень досвіду",
  "languages": "Мова спілкування",
  "load_more": "Більше",
  "save": "Зберегти",
  "delete_this_contact": "Видалити цей контакт",
  "add_to_bank": "Додати в Digital Bank",
  "socials": "Соціальні мережі",
  "subscribers": "Підписники",
  "get_data": "Помилка завантаження даних",
  "get_access": "Отримати доступ",
  "familiar": "Якщо ви знайомі з цим контактом",
  "text_add": "Ви можете додати його до свого цифрового банку для зберігання. ",
  "level_access": "Рівень доступу",
  "add_contact_bank": "Ви успішно додали контакт",
  "filter": "Фільтр",
  "reset_filters": "Скинути всі фільтри",
  "apply": "Застосувати",
  "expertise_level": "Рівень досвіду",
  "new_contact": "Ви додаєте новий контакт",
  "in_bank": "У вашому Digital Bank",
  "search_title": "Пошук у CardBook",
  "search_notif": "Це віртуальний каталог з нескінченним потоком візиток, і щоб бути серед них, заповніть свій профіль.",
  "tags": "Теги",
  "profile_info": "Профіль",
  "profile_preview": "Попередній перегляд профілю",
  "your_profile_must_be_completed": "Щоб з'явитися в загальному пошуку, ваш профіль повинен бути заповнений.",
  "basic_information": "Основна інформація",
  "basic_information_text": "Вкажіть свої персональні дані, щоб вас було легше знайти та викликати більше довіри у спілкуванні.",
  "basic_information_positioning": "Ким ти себе позиціонуєш?",
  "basic_information_positioning_placeholder": "макс. 30 символів",
  "avatar_cover_title": "Аватар і обкладинка",
  "avatar_cover_text": "Замініть системні образи на власні. ",
  "upload_new_cover": "Завантажте нову обкладинку",
  "location": "Місцезнаходження",
  "location_text": "Додайте інформацію про ваше основне місцезнаходження. Потенційні клієнти зможуть знайти вас за відповідними фільтрами.",
  "additional_information": "Додаткова інформація",
  "additional_information_text": "Додаткова інформація сильно впливає на довіру у взаємодії між користувачами. ",
  "interest_needs": "Інтереси та потреби",
  "interest_needs_text": "Підвищіть цінність свого нетворкінг-профілю, поділившись поточними потребами та інтересами.",
  "save_profile": "Зберегти профіль",
  "show": "Показати",
  "clear": "Очистити",
  "potential_income": "Ваш потенційний дохід від контактів вашого CardMarket",
  "calculate": "Обчислити",
  "networking": "Калькулятор доходу від нетворкінгу",
  "text_calculator": "Привіт! Ми створили цей калькулятор для зручності розрахунку доходу при торгівлі на платформі.",
  "comment": "Коментар",
  "card_market": "CardMarket",
  "profit_potential": "Потенціал прибутку",
  "calculation_result": "Результат розрахунку",
  "monthly_sales": "Щомісячний потенціал продажів",
  "per_month": "Прибуток на місяць",
  "per_year": "Прибуток на рік",
  "taking": "Враховуючи*",
  "plat_fee": "Комісія платформи",
  "contact_fee": "Комісія контакту",
  "bank_fee": "Банківська комісія",
  "question_1": "Що таке нетворкінг-калькулятор?",
  "text_1": "Це інтерактивний інструмент, який дозволяє оцінити потенційний дохід від використання нашої платформи. Після того, як ви введете свої дані, калькулятор покаже вам приблизний місячний і річний дохід і разові продажі на один контакт. Це чудовий спосіб оцінити потенціал заробітку вашої мережі контактів і почати використовувати нашу платформу для покращення вашого бізнесу або кар'єри.",
  "question_2": "Я зможу укладати лише 20 угод на місяць?",
  "text_2": "Дохід у «Калькуляторі нетворкінгу» розраховується на основі введених користувачем даних про ціну доступу до контактів на трьох рівнях довіри. Калькулятор враховує загальну суму цін контактів і оцінює потенційний прибуток за рік, місяць і разовий продаж для кожного контакту. Враховуючи, що користувач може знайомити до 20 осіб на день, калькулятор визначає потенціал продажів кожного рівня доступу, розділивши його на 50%.",
  "question_3": "Які дані потрібно ввести в калькулятор?",
  "text_3": "Щоб скористатися калькулятором, вам потрібно ввести кількість угод, які ви можете здійснити за місяць (в середньому не більше 20) і середню бажану ціну для кожного рівня доступу (A, B, C) на нашій платформі. На основі цих даних калькулятор автоматично розрахує ваш потенційний заробіток, враховуючи можливість продажу кожного контакту і кількість продажів на місяць.",
  "question_4": "У чому різниця між рівнями доступу (A, B, C)?",
  "text_4": "Рівень А — високий рівень довіри до людини. Ви перебуваєте з нею у близьких стосунках і підтримуєте постійну комунікацію. Рівень В — середній рівень довіри. Ви досить регулярно спілкуєтесь з контактом і підтримуєте зв'язок. Рівень С — мінімальний рівень довіри. Ви знайомі з людиною, але не маєте з нею частого контакту.",
  "occupation": "Рід діяльності",
  "can_help": "Можу допомогти з...",
  "looking": "Шукаю",
  "can_introduce": "Можу познайомити з...",
  "profile_info_text": "Вкажіть теги, які найкраще вас описують. Це зробить вас більш доступними в загальному пошуку.",
  "update_profile": "Ви успішно оновили профіль",
  "upload_new": "Завантажити",
  "edit_size": "Редагувати",
  "remove": "Видалити",
  "account_info": "Інформація про обліковий запис",
  "mobile": "Номер мобільного",
  "change": "Змінити",
  "not_confirmed": "Не підтверджено",
  "confirmed": "Підтверджено",
  "security_level": "Рівень безпеки",
  "good": "Добре",
  "average": "Середній",
  "delete_profile": "Видалити профіль",
  "delete_btn": "Видалити",
  "delete_prof_msg": "Ви впевнені, що хочете видалити свій обліковий запис?",
  "delete_prof": "Ця дія не може бути скасована, а всі ваші дані будуть безповоротно втрачені.",
  "deleted_msg": "Ваш профіль успішно видалено.",
  "add_password": "Додайте пароль",
  "pass_modal_text": "На смс-код можна встановити пароль, який буде потрібно при вході з нового пристрою",
  "repeat_password": "Повторіть пароль",
  "pin_mail_subtitle": "На цю електронну адресу надіслано код підтвердження.",
  "email_confirmed": "Електронну адресу успішно додано",
  "pass_added": "Пароль додано",
  "pass_msg": "Ваш обліковий запис тепер ще безпечніший 💪🏻",
  "email_subtitle": "Щоб відновити пароль, якщо ви його забули, додайте свою електронну адресу",
  "confirm_email": "Підтвердьте свою електронну адресу",
  "confirm_email_text": "Будь ласка, підтвердіть свою електронну пошту, щоб верифікувати свій обліковий запис і отримати доступ до всіх функцій платформи.",
  "glad_to_see": "Ми раді вас бачити. Нумо покращувати ваш нетворкінг разом!",
  "deals_month": "Угоди/місяць",
  "per_month_per": "/місяць.",
  "get_start": "Почніть роботу з CardBook тут",
  "steps": "3 кроки",
  "deals": "Угод",
  "avg_trans_time": "Сер. час. транз. ",
  "rating": "Рейтинг",
  "access": "Доступ",
  "show_more": "Показати більше",
  "what_are_they_and_how_do_they_differ": "Рівні доступу: що це таке та чим вони відрізняються? ",
  "has_access": "Має доступ",
  "change_email": "Зміна електронної пошти",
  "change_email_subtitle": "Ви можете змінити свою електронну адресу не частіше двох разів на 30 днів",
  "change_phone_subtitle": "Ви можете змінити номер телефону не частіше двох разів на 30 днів",
  "new_email": "Нова електронна пошта",
  "new_phone": "Номер телефону",
  "current_password": "Введіть поточний пароль",
  "change_email_hint": "Пароль для входу в обліковий запис",
  "pin_mail_change": "Ми надіслали код на введену вами електронну адресу.",
  "email_success": "Електронну адресу змінено на",
  "change_phone": "Змінити номер телефону",
  "change_pass": "Змінити пароль",
  "new_pass": "Новий пароль",
  "cancel": "Скасувати",
  "change_pass_confirm": "Підтвердити зміну пароля",
  "change_pass_subtitle": "Якщо ви хочете встановити новий пароль, натисніть «Змінити пароль»",
  "pass_success": "Ваш пароль успішно змінено",
  "success": "Успіх!",
  "phone_success": "Ваш номер мобільного телефону оновлено.",
  "error_correct": "В одному чи кількох полях є помилка. ",
  "contact_deleted": "Контакт видалено",
  "reset_success": "Ваш пароль успішно скинуто.",
  "click_to_download_your_first_business_card": "Натисніть, щоб завантажити свою першу візитну картку",
  "card_market_box_title": "Цей розділ буде доступний дуже скоро, ",
  "card_market_box_subtitle": "але тим часом ви можете дізнатися свій потенціал заробітку",
  "add_new_cards": "Додати нову візитку",
  "add_new_cards_text": "Введіть дані людини, про яку ви хочете додати інформацію, щоб перевірити наявність збігів на платформі",
  "referral": "Реферальна система",
  "referral_welcome": "Наша реферальна система наразі доступна виключно для власників спільнот.",
  "apply_now": "Подати заявку зараз!",
  "community_owner": "Якщо ви власник спільноти, ви можете подати заявку на перевірку.",
  "ref_approve": "Після схвалення ви отримаєте доступ до реферальної програми, а ваш обліковий запис буде підтверджено галочкою.",
  "verification": "Перевірка",
  "verif_desc": "Перевірка гарантує, що особистий профіль справді належить власнику спільноти. ",
  "verif_text": "Щоб перевірити, переконайтеся",
  "link_mob": "Прив'язаний номер мобільного телефону",
  "link_mob_required": "Щоб подати заявку, прив'яжіть номер мобільного телефону.",
  "link_mob_go_settings": "Перейти до налаштувань",
  "profile_photo": "Набір фотографій профілю",
  "basic_info": "Основна інформація заповнена",
  "community": "Спільнота налічує 100 учасників",
  "ref_form_title": "Якщо ви є власником спільноти, будь ласка, заповніть форму та розкажіть нам трохи про себе та свою компанію.",
  "ref_form_subtitle": "Після отримання заявки наш менеджер зв'яжеться з вами напряму.",
  "community_name": "Назва вашої спільноти",
  "community_link": "Посилання на спільноту",
  "members_title": "Кількість учасників у вашій спільноті та місцезнаходження (міжнародне/ назва країни з найбільшою кількістю учасників)",
  "description_title": "Коротко опишіть, для кого ваша спільнота",
  "value_title": "Яка його цінність",
  "activities_title": "Які заходи ви організовуєте (масштабування, офлайн-зустрічі)",
  "your_reply": "Твоя відповідь",
  "last_login": "Час останнього входу",
  "ref_thanks": "Дякуємо за вашу заявку!",
  "receive_approve": "Ми отримали її і зараз перевіряємо ваш статус Власника Спільноти. Будь ласка, очікуйте на оновлення найближчим часом.",
  "close": "Закрити",
  "referral_form_confirmed": "Вашу заявку подано. Ми зв'яжемося з вами найближчим часом. Із найкращими побажаннями!",
  "link_invite": "Посилання-запрошення",
  "ref_percent": "Отримайте {percent}% усіх транзакцій, які здійснюють ваші реферали!",
  "invites": "Мої запрошення",
  "total_invites": "Всього запрошень",
  "potential_earn": "Потенційний заробіток",
  "transaction_qty": "Здійснено транзакцій",
  "balance": "Загальний баланс",
  "dynamic_earn": "Динаміка доходів",
  "period": "за останні 12 місяців",
  "invite": "Запросити",
  "copied": "Скопійовано",
  "restore": "Відновити",
  "add_photo_warning": "Якщо ви хочете додати новий контакт до свого цифрового банку, вам потрібно додати фотографію",
  "connects_qty": "користувачі можуть підключити вас",
  "query_no_results": "Ваш запит не дав результатів",
  "digital_bank_search": "Пошук цифрового банку",
  "level": "Рівень",
  "arts_and_entertainment": "Мистецтво та розваги",
  "diversified_holding": "Багатопрофільний холдинг",
  "education": "Освіта",
  "electronic_commerce": "Електронна комерція",
  "fashion_and_beauty_industry": "Індустрія моди та краси",
  "finance_banks_insurance_investments_": "Фінанси (банки/страхування/інвестиції)",
  "hotel_and_restaurant_business": "Готельно-ресторанний бізнес",
  "industry": "Промисловість",
  "it_internet_digital": "IT, Інтернет, Діджитал",
  "marketing": "Маркетинг",
  "media_and_communications": "Медіа, комунікації та ЗМІ",
  "medicine": "Медицина",
  "private_equility_and_venture_investments": "Приватний капітал та венчурні інвестиції",
  "real_estate_and_development": "Нерухомість та девелопмент",
  "retail_trade": "Retail/Торгівля",
  "state_and_municipal_administration": "Державне та муніципальне управління",
  "tourism_and_travel": "Туризм і подорожі",
  "construction": "Будівництво",
  "finance": "Фінанси",
  "information_technology": "Інформаційні технології",
  "jurisprudence": "Юриспруденція",
  "marketing_advertising_pr": "Маркетинг, реклама, PR ",
  "personnel_management": "Управління персоналом",
  "procurement": "Закупівлі",
  "project_management": "Управління проектами",
  "sales": "Продажі",
  "strategy": "Стратегія",
  "transport_logistics": "Транспортна логістика",
  "product_development": "Розробка продукту",
  "top_management": "Топ-менеджмент",
  "operational_efficiency": "Ефективність операцій",
  "design": "Дизайн",
  "increasing_labor_productivity": "Підвищення продуктивності праці",
  "engineering_activities": "Інженерна діяльність",
  "b2b_marketing": "B2B маркетинг",
  "b2c_marketing": "B2C маркетинг",
  "digital_marketing": "Цифровий маркетинг",
  "smm": "SMM",
  "analysis_of_the_competitive_environment": "Аналіз конкурентного середовища",
  "brand_management": "Бренд менеджмент",
  "market_research": "Дослідження ринку",
  "merchandising": "Мерчандайзинг",
  "organisation_of_pr_campaigns": "Організація PR-кампаній",
  "marketing_strategy_development": "Розробка маркетингової стратегії",
  "pr_strategy_development": "Розробка PR-стратегії",
  "advertising_campaing": "Рекламні кампанії",
  "market_segmentation": "Сегментація ринку",
  "trade_marketing": "Торговий маркетинг",
  "audit": "Аудит",
  "financial_statements": "Фінансова звітність",
  "accounting": "Бухгалтерський облік",
  "investments": "Інвестиції",
  "currency_operations": "Валютні операції",
  "treasury_department": "Департамент казначейства",
  "taxes": "податки",
  "tax_reporting": "Податкова звітність",
  "tax_optimization": "Оптимізація податків",
  "assessment_of_investment_projects": "Оцінка інвестиційних проектів",
  "risk_management": "Управління ризиками",
  "investment_management": "Управління інвестиціями",
  "management_accounting": "Управлінський облік",
  "financial_modeling": "Фінансове моделювання",
  "financial_planning": "Фінансове планування",
  "the_financial_analysis": "Фінансовий аналіз",
  "financial_management": "Фінансовий менеджмент",
  "fea_procurement_of_services": "ЗЕД",
  "purchase_for_investment_projects": "Закупівля для інвестиційних проектів",
  "supplier_classification_and_segmentation": "Класифікація та сегментація постачальників",
  "procurement_optimization": "Оптимізація закупівель",
  "procurement_planning": "Планування закупівель",
  "supply_development": "Розвиток постачання",
  "materials_management": "Управління матеріалами",
  "purchasing_management": "Управління закупівлями",
  "inventory_management": "Управління запасами",
  "category_management": "Управління категоріями",
  "supplier_performance_management": "Управління продуктивністю постачальника",
  "big_data": "Великі дані",
  "blockchain": "Блокчейн",
  "data_mining": "Видобуток даних",
  "administration": "Адміністрація",
  "implementation": "Реалізація",
  "architecture": "Архітектура",
  "external_audit_of_information_systems": "Зовнішній аудит інформаційних систем",
  "infrastructure": "Інфраструктура",
  "programming": "Програмування",
  "artificial_intelligence": "Штучний інтелект",
  "computer_security": "Комп'ютерна безпека",
  "software_development": "Розробка програмного забезпечення",
  "technical_support": "Технічна підтримка",
  "b2b_sales": "Продажі B2B",
  "b2c_sales": "Продажі B2C",
  "b2g_sales": "Продажі B2G",
  "sales_analysis": "Аналіз продажів",
  "commercial_management": "Комерційний менеджмент",
  "sales_support": "Підтримка продажів",
  "after_sales_post": "Пошта після продажу",
  "sales_development": "Розвиток продажів",
  "development_of_a_sales_strategy": "Розробка стратегії продажів",
  "telephone_sales": "Продаж по телефону",
  "sales_management": "Управління продажами",
  "civil_engineering": "Цивільна інженерія",
  "road_construction": "Дорожнє будівництво",
  "commercial_real_estate": "Комерційна нерухомість",
  "construction_control": "Будівельний контроль",
  "construction_mechanization": "Будівельна механізація",
  "property_valuation": "Оцінка майна",
  "industrial_real_estate": "Промислова нерухомість",
  "construction_support": "Підтримка будівництва",
  "property_management": "Управління майном",
  "construction_management": "Управління будівництвом",
  "developer_functions": "Функції розробника",
  "internal_logistics": "Внутрішня логістика",
  "supply_control": "Контроль постачання",
  "logistics_management": "Управління логістикою",
  "optimization_of_logistics_processes": "Оптимізація логістичних процесів",
  "demand_planning": "Планування попиту",
  "supply_chain_planning": "Планування ланцюга поставок",
  "production_planning": "Планування виробництва",
  "distribution_logistics": "Логістика розподілу",
  "warehouse_logistics": "Складська логістика",
  "transportation_management": "Транспортний менеджмент",
  "supply_chain_management": "Управління ланцюгом поставок",
  "staff_adaptation": "Адаптація персоналу",
  "hr_records_management": "Ведення кадрового діловодства",
  "compensation_and_benefits": "Компенсації та пільги",
  "motivation": "Мотивація",
  "personnel_assessment": "Оцінка персоналу",
  "professional_competencies": "Професійні компетенції",
  "development": "Розвиток",
  "recruitment": "Вербування",
  "development_of_policies_and_procedures": "Розробка політик і процедур",
  "staff_reduction": "Скорочення персоналу",
  "talent_management": "Управління талантами",
  "managerial_competencies": "Управлінські компетенції",
  "copyright": "Авторське право",
  "administrative_law": "Адміністративне право",
  "shareholding_law": "Акціонерне право",
  "audit_of_legal_documents": "Аудит правовстановлюючих документів",
  "civil_law": "Цивільне право",
  "corporate_governance": "Корпоративне управління",
  "international_law": "Міжнародне право",
  "tax_law": "Податкове право",
  "development_of_legal_documents": "Розробка правових документів",
  "litigation": "судовий процес",
  "customs_law": "Митне право",
  "labor_law": "Трудове право",
  "economic_law": "Господарське право",
  "private_right": "Приватне право",
  "business_analysis": "Бізнес аналіз",
  "business_process_optimization": "Оптимізація бізнес-процесів",
  "project_planning": "Планування проекту",
  "project_documentation": "Проектна документація",
  "development_of_technical_specifications": "Розробка технічного завдання",
  "digital_strategy": "Цифрова стратегія",
  "corporate_strategy": "Корпоративна стратегія",
  "marketing_strategy": "Маркетингова стратегія",
  "modeling": "Моделювання",
  "strategy_development": "Розробка стратегії",
  "implementation_of_the_strategy": "Реалізація стратегії",
  "strategic_analysis": "Стратегічний аналіз",
  "strategic_consulting": "Стратегічний консалтинг",
  "strategic_marketing": "Стратегічний маркетинг",
  "strategic_management": "Стратегічний менеджмент",
  "strategic_planning": "Стратегічне планування",
  "positioning_strategy": "Стратегія позиціонування ",
  "sales_strategy": "Стратегія продажів",
  "promotion_strategy": "Стратегія просування",
  "development_strategy": "Стратегія розвитку",
  "strategy_management": "Стратегічний менеджмент",
  "b2b": "B2B",
  "b2c": "B2C",
  "b2g": "B2G",
  "c2c": "C2C",
  "fintech": "Фінтех",
  "business_modeling": "Бізнес-моделювання",
  "conversion_boost": "Підвищення конверсії",
  "e_learning": "Електронне навчання",
  "electronic_banking": "Електронний банкінг",
  "email_marketing": "Електронний маркетинг",
  "electronic_information_exchange": "Електронний обмін інформацією",
  "analysis_of_consumer_preferences": "Аналіз споживчих переваг",
  "testing": "Тестування",
  "export_sales ": "Продажі на експорт",
  "construction_development": "Розвиток будівництва",
  "logistics_business_modeling": "Моделювання логістичного бізнесу",
  "hr_strategy": "HR стратегія",
  "corporate_law": "Корпоративне право",
  "criminal_law": "Кримінальне право",
  "analytics": "Аналітика",
  "road_map": "Дорожня карта",
  "usability": "Юзабіліті",
  "use_case_analysis": "Аналіз варіантів використання",
  "bringing_the_product_to_market": "Виведення продукту на ринок",
  "product_interface_design": "Дизайн інтерфейсу",
  "launch_of_new_products": "Запуск нових продуктів",
  "needs_research": "Потребує дослідження",
  "industrial_design": "Індустріальний дизайн",
  "new_product_development": "Розробка нового продукту",
  "development_of_a_product_development_strategy": "Розробка стратегії розвитку продукту",
  "product_management": "Менеджмент продукту",
  "economic_analysis": "Економічний аналіз",
  "crisis_management": "Кризовий менеджмент",
  "corporate_leadership": "Корпоративне лідерство",
  "organisation_management": "Менеджмент організації",
  "operations_management": "Управління операціями",
  "organizational_design": "Організаційний дизайн",
  "process_and_project_management": "Управління процесами та проектами",
  "top_risk_management": "Управління ризиками",
  "top_strategic_management": "Стратегічний менеджмент",
  "business_process_management": "Управління бізнес-процесами",
  "improving_the_quality_of_the_product_service": "Підвищення якості продукту/послуги",
  "cost_reduction": "Зниження витрат",
  "improvement_of_business_processes": "Удосконалення бізнес-процесів",
  "3d_visualization": "3D візуалізація",
  "layout": "Макет",
  "exhibition_stage_design": "Оформлення виставки/сценізації",
  "vjing_vj": "VJing (VJ)",
  "print_design": "Друк дизайн",
  "presentation_design": "Дизайн презентації",
  "illustration": "Ілюстрація",
  "interface_design": "Дизайн інтерфейсу",
  "infographics": "Інфографіка",
  "motion_design": "Моушн-дизайн",
  "ux_ui_design": "UX/UI дизайн",
  "identity_development": "Розвиток ідентичності",
  "character_development": "Розвиток характеру",
  "creating_a_brand_book": "Створення брендбуку",
  "fea": "ЗЕД",
  "procurement_of_services": "Закупівля послуг",
  "how_add_card": "Як додати візитку в Digital Bank за 3 кліки?",
  "levels_mean": "Що означають рівні A, B, C?",
  "how_potential_income": "Як працює калькулятор потенційного доходу?",
  "how_referral_system": "Як подати заявку на використання реферальної системи?",
  "answers_community": "Відповіді на ці та інші питання доступні в нашому боті та спільноті",
  "join_community": "Хочу в спільноту",
  "get_help": "Отримати допомогу",
  "your_help": "Ваш Центр Допомоги",
  "help_text": "Питання, проблеми, ідеї - ми готові допомогти та рухатися вперед разом 👇🏻",
  "complete_profile_occu": "Заповнити профіль",
  "where_begin": "Із чого почати",
  "afghanistan": "Афганістан",
  "aland_islands": "Аландські острови",
  "albania": "Албанія",
  "algeria": "Алжир",
  "american_samoa": "Американське Самоа",
  "andorra": "Андорра",
  "angola": "Ангола",
  "anguilla": "Ангілья",
  "antarctica": "Антарктика",
  "antigua_and_barbuda": "Антигуа і Барбуда",
  "argentina": "Аргентина",
  "armenia": "Вірменія",
  "aruba": "Аруба",
  "australia": "Австралія",
  "austria": "Австрія",
  "azerbaijan": "Азербайджан",
  "bahamas": "Багамські Острови",
  "bahrain": "Бахрейн",
  "bangladesh": "Бангладеш",
  "barbados": "Барбадос",
  "belarus": "Білорусь",
  "belgium": "Бельгія",
  "belize": "Беліз",
  "benin": "Бенін",
  "bermuda": "Бермуди",
  "bhutan": "Бутан",
  "bolivia_plurinational_state_of": "Болівія, Многонаціональна Республіка",
  "bosnia_and_herzegovina": "Боснія і Герцеговина",
  "botswana": "Ботсвана",
  "brazil": "Бразилія",
  "british_indian_ocean_territory": "Британська Територія в Індійському Океані",
  "brunei_darussalam": "Бруней-Даруссалам",
  "bulgaria": "Болгарія",
  "burkina_faso": "Буркіна-Фасо",
  "burundi": "Бурунді",
  "cambodia": "Камбоджа",
  "cameroon": "Камерун",
  "canada": "Канада",
  "cape_verde": "Кабо-Верде",
  "cayman_islands": "Кайманові острови",
  "central_african_republic": "Центральноафриканська Республіка",
  "chad": "Чад",
  "chile": "Чилі",
  "china": "Китай",
  "christmas_island": "Острів Різдва",
  "cocos_keeling_islands": "Кокосові (Кілінг) острови",
  "colombia": "Колумбія",
  "comoros": "Коморські Острови",
  "congo": "Конго",
  "congo_the_democratic_republic_of_the_congo": "Демократична Республіка Конго",
  "cook_islands": "Острови Кука",
  "costa_rica": "Коста-Рика",
  "cote_d_ivoire": "Кот-д'Івуар",
  "croatia": "Хорватія",
  "cuba": "Куба",
  "cyprus": "Кіпр",
  "czech_republic": "Чеська Республіка",
  "denmark": "Данія",
  "djibouti": "Джибуті",
  "dominica": "Домініка",
  "dominican_republic": "Домініканська Республіка",
  "ecuador": "Еквадор",
  "egypt": "Єгипет",
  "el_salvador": "Сальвадор",
  "equatorial_guinea": "Екваторіальна Гвінея",
  "eritrea": "Еритрея",
  "estonia": "Естонія",
  "ethiopia": "Ефіопія",
  "falkland_islands_malvinas_": "Фолклендські острови (Мальвінські)",
  "faroe_islands": "Фарерські острови",
  "fiji": "Фіджі",
  "finland": "Фінляндія",
  "france": "Франція",
  "french_guiana": "Французька Гвіана",
  "french_polynesia": "Французька Полінезія",
  "gabon": "Габон",
  "gambia": "Гамбія",
  "georgia": "Грузія",
  "germany": "Німеччина",
  "ghana": "Гана",
  "gibraltar": "Гібралтар",
  "greece": "Греція",
  "greenland": "Гренландія",
  "grenada": "Гренада",
  "guadeloupe": "Гваделупа",
  "guam": "Гуам",
  "guatemala": "Гватемала",
  "guernsey": "Гернсі",
  "guinea": "Гвінея",
  "guinea_bissau": "Гвінея-Бісау",
  "guyana": "Гаяна",
  "haiti": "Гаїті",
  "holy_see_vatican_city_state_": "Святий Престол (Місто-Держава Ватикан)",
  "honduras": "Гондурас",
  "hong_kong": "Гонконг",
  "hungary": "Угорщина",
  "iceland": "Ісландія",
  "india": "Індія",
  "indonesia": "Індонезія",
  "iran_islamic_republic_of_persian_gulf": "Іран, Ісламська Республіка Перської Затоки",
  "iraq": "Ірак",
  "ireland": "Ірландія",
  "isle_of_man": "Острів Мен",
  "israel": "Ізраїль",
  "italy": "Італія",
  "jamaica": "Ямайка",
  "japan": "Японія",
  "jersey": "Джерсі",
  "jordan": "Йорданія",
  "kazakhstan": "Казахстан",
  "kenya": "Кенія",
  "kiribati": "Кірибаті",
  "korea_democratic_people_s_republic_of_korea": "Корейська Народно-Демократична Республіка Корея",
  "korea_republic_of_south_korea": "Республіка Корея",
  "kuwait": "Кувейт",
  "kyrgyzstan": "Киргизстан",
  "laos": "Лаос",
  "latvia": "Латвія",
  "lebanon": "Ліван",
  "lesotho": "Лесото",
  "liberia": "Ліберія",
  "libyan_arab_jamahiriya": "Лівійська Арабська Джамахірія",
  "liechtenstein": "Ліхтенштейн",
  "lithuania": "Литва",
  "luxembourg": "Люксембург",
  "macao": "Макао",
  "macedonia": "Македонія",
  "madagascar": "Мадагаскар",
  "malawi": "Малаві",
  "malaysia": "Малайзія",
  "maldives": "Мальдіви",
  "mali": "Малі",
  "malta": "Мальта",
  "marshall_islands": "Маршаллові острови",
  "martinique": "Мартиніка",
  "mauritania": "Мавританія",
  "mauritius": "Маврикій",
  "mayotte": "Майотта",
  "mexico": "Мексика",
  "micronesia_federated_states_of_micronesia": "Мікронезія, Федеративні Штати Мікронезії",
  "moldova": "Молдова",
  "monaco": "Монако",
  "mongolia": "Монголія",
  "montenegro": "Чорногорія",
  "montserrat": "Монтсеррат",
  "morocco": "Марокко",
  "mozambique": "Мозамбік",
  "myanmar": "М'янма",
  "namibia": "Намібія",
  "nauru": "Науру",
  "nepal": "Непал",
  "netherlands": "Нідерланди",
  "netherlands_antilles": "Нідерландські Антильські острови",
  "new_caledonia": "Нова Каледонія",
  "new_zealand": "Нова Зеландія",
  "nicaragua": "Нікарагуа",
  "niger": "Нігер",
  "nigeria": "Нігерія",
  "niue": "Ніуе",
  "norfolk_island": "Острів Норфолк",
  "northern_mariana_islands": "Північні Маріанські острови",
  "norway": "Норвегія",
  "oman": "Оман",
  "pakistan": "Пакистан",
  "palau": "Палау",
  "palestinian_territory_occupied": "Палестинська територія, Окупована",
  "panama": "Панама",
  "papua_new_guinea": "Папуа-Нова Гвінея",
  "paraguay": "Парагвай",
  "peru": "Перу",
  "philippines": "Філіппіни",
  "pitcairn": "Піткерн",
  "poland": "Польща",
  "portugal": "Португалія",
  "puerto_rico": "Пуерто-Ріко",
  "qatar": "Катар",
  "romania": "Румунія",
  "russia": "Росія",
  "rwanda": "Руанда",
  "reunion": "Реюньйон",
  "saint_barthelemy": "Сен-Бартельмі",
  "saint_helena_ascension_and_tristan_da_cunha": "Острів Святого Єлены, Вознесіння і Трістан-да-Кунья",
  "saint_kitts_and_nevis": "Сент-Кіттс і Невіс",
  "saint_lucia": "Сент-Люсія",
  "saint_martin": "Сент-Мартін",
  "saint_pierre_and_miquelon": "Сен-П'єр і Мікелон",
  "saint_vincent_and_the_grenadines": "Сент-Вінсент і Гренадини",
  "samoa": "Самоа",
  "san_marino": "Сан-Марино",
  "sao_tome_and_principe": "Сан-Томе і Принсіпі",
  "saudi_arabia": "Саудівська Аравія",
  "senegal": "Сенегал",
  "serbia": "Сербія",
  "seychelles": "Сейшельські острови",
  "sierra_leone": "Сьєрра-Леоне",
  "singapore": "Сінгапур",
  "slovakia": "Словаччина",
  "slovenia": "Словенія",
  "solomon_islands": "Соломонові острови",
  "somalia": "Сомалі",
  "south_africa": "Південна Африка",
  "south_sudan": "Південний Судан",
  "south_georgia_and_the_south_sandwich_islands": "Південна Джорджія і Південні Сендвічеві острови",
  "spain": "Іспанія",
  "sri_lanka": "Шрі-Ланка",
  "sudan": "Судан",
  "suriname": "Суринам",
  "svalbard_and_jan_mayen": "Шпіцберген і Ян-Маєн",
  "swaziland": "Свазіленд",
  "sweden": "Швеція",
  "switzerland": "Швейцарія",
  "syrian_arab_republic": "Сирійська Арабська Республіка",
  "taiwan": "Тайвань",
  "tajikistan": "Таджикистан",
  "tanzania_united_republic_of_tanzania": "Танзанія, Об'єднана Республіка Танзанія",
  "thailand": "Таїланд",
  "timor_leste": "Східний Тимор",
  "togo": "Того",
  "tokelau": "Токелау",
  "tonga": "Тонга",
  "trinidad_and_tobago": "Тринідад і Тобаго",
  "tunisia": "Туніс",
  "turkey": "Туреччина",
  "turkmenistan": "Туркменістан",
  "turks_and_caicos_islands": "Острови Теркс і Кайкос",
  "tuvalu": "Тувалу",
  "uganda": "Уганда",
  "ukraine": "Україна",
  "united_arab_emirates": "Об'єднані Арабські Емірати",
  "united_kingdom": "Велика Британія",
  "united_states": "Сполучені Штати",
  "uruguay": "Уругвай",
  "uzbekistan": "Узбекистан",
  "vanuatu": "Вануату",
  "venezuela_bolivarian_republic_of_venezuela": "Венесуела, Боліваріанська Республіка Венесуела",
  "vietnam": "В'єтнам",
  "virgin_islands_british": "Віргінські острови, Британські",
  "virgin_islands_u_s_": "Віргінські острови, США",
  "wallis_and_futuna": "Уолліс і Футуна",
  "yemen": "Ємен",
  "zambia": "Замбія",
  "zimbabwe": "Зімбабве",
  "okay": "Окей",
  "profile": "Профіль",
  "displayed_here": "Ваші контакти будуть відображені тут",
  "avg_price": "Сер. ціна",
  "delete_from_bank": "Видалити з Digital Bank",
  "levels_on_platform": "Рівні доступу  на платформі",
  "text_banner": "Дізнайтеся, що це і як правильно їх встановлювати для своїх контактів, натискайте на цей банер",
  "levels": "Рівні доступу ",
  "on_platform": "на платформі",
  "text_banner_help": "Знаходьте відповіді та звертайтеся до нас  у розділі підтримки. Ваш комфорт - наш пріоритет.",
  "banner_help": "Потрібна допомога?",
  "upload_card": "Завантажте свою першу візитку тут",
  "welcome_digital": "Ласкаво просимо до Digital Bank",
  "text_card_banner": "Ваш особистий маркет візиток знаходиться в розробці. Використовуйте калькулятор, щоб дізнатися свій потенційний дохід.",
  "level_plat": "Рівні доступу на платформі",
  "text_abc_banner": "Дізнайтеся, що це і як правильно їх встановлювати для своїх контактів, натискайте на цей банер",
  "text_digital_banner": "Ваш особистий цифровий банк візиток, де ви можете зберігати та додавати найцінніші контакти",
  "contacts_s": "Контактів",
  "invite_header": "Запроси в CardBook",
  "invite_text": "Кожен, хто реєструється, стає частиною вашого DigitalBank.",
  "link_one": "Посилання",
  "contact": "Контакт",
  "active_link": "Посилання активне 48 годин",
  "update_link": "Оновити Посилання",
  "visible": "Видимий тільки вам",
  "text_pop": "Використовується для вашої зручності та швидкого пошуку",
  "add_to_my_bank": "Додати до мого Digital Bank",
  "additional_account": "Додатковий захист акаунта",
  "to_login": "Щоб увійти, змінити налаштування безпеки",
  "necessary_to_reset": "Необхідно для скидання пароля, активації облікового запису та отримання повідомлень про транзакції.",
  "comment_modal": "A – близькі контакти, B – регулярні, C – знайомі",
  "click_connec": "Зв'язок в один клік",
  "connec_text": "Додайте посилання на свою соцмережу або месенджер, щоб залишатися на зв'язку поза платформою.",
  "your_link": "Ваше посилання",
  "no_link": "У цього користувача немає вказаних контактних даних.",
  "text_contact": "Користувач залишив зручний  для нього спосіб зв'язку.",
  "afar": "Афарська",
  "abkhazian": "Абхазська",
  "avestan": "Авестійська",
  "afrikaans": "Австралійська",
  "akan": "Акан",
  "amharic": "Амхарська",
  "aragonese": "Арагонська",
  "arabic": "Арабська",
  "assamese": "Ассамська",
  "avaric": "Аварська",
  "aymara": "Аймара",
  "azerbaijani": "Азербайджанська",
  "bashkir": "Башкирська",
  "belarusian": "Білоруська",
  "bulgarian": "Болгарська",
  "bihari_languages": "Бігарійські мови",
  "bislama": "Біслама",
  "bambara": "Бамбара",
  "bengali": "Бенгальська",
  "tibetan": "Тибетська",
  "breton": "Бретонська",
  "bosnian": "Боснійська",
  "catalan": "Каталонська",
  "chechen": "Чеченська",
  "chamorro": "Чаморро",
  "corsican": "Корсиканська",
  "cree": "Крі",
  "czech": "Чеська",
  "chuvash": "Чуваська",
  "welsh": "Валлійська",
  "danish": "Данська",
  "german": "Німецька",
  "divehi": "Дівехі",
  "dzongkha": "Дзонг-кха",
  "ewe": "Еве",
  "greek_modern_1453_": "Грецька, сучасна (1453 р.)",
  "english": "Англійська",
  "esperanto": "Есперанто",
  "spanish": "Іспанська",
  "estonian": "Естонська",
  "basque": "Баскська",
  "persian": "Перська",
  "fulah": "Фула",
  "finnish": "Фінська",
  "fijian": "Фіджі",
  "faroese": "Фарерська",
  "french": "Французька",
  "western_frisian": "Західно-фризька",
  "irish": "Ірландська",
  "gaelic": "Гельська",
  "galician": "Галісійська",
  "guarani": "Гуарані",
  "gujarati": "Гуджараті",
  "manx": "Менкс",
  "hausa": "Хауса",
  "hebrew": "Іврит",
  "hindi": "Гінді",
  "hiri_motu": "Хірі моту",
  "croatian": "Хорватська",
  "haitian": "Гаїтянська",
  "hungarian": "Угорська",
  "armenian": "Вірменська",
  "herero": "Хереро",
  "indonesian": "Індонезійська",
  "igbo": "Ігбо",
  "sichuan_yi": "Сичуань йі",
  "inupiaq": "Інупіак",
  "ido": "Ідо",
  "icelandic": "Ісландська",
  "italian": "Італійська",
  "inuktitut": "Інуктітут",
  "japanese": "Японська",
  "javanese": "Яванська",
  "georgian": "Грузинська",
  "kongo": "Конго",
  "kikuyu": "Кікуйю",
  "kuanyama": "Куаньяма",
  "kazakh": "Казахська",
  "greenlandic": "Гренландська",
  "central_khmer": "Центрально-хмерська",
  "kannada": "Каннада",
  "korean": "Корейська",
  "kanuri": "Канурі",
  "kashmiri": "Кашмірська",
  "kurdish": "Курдська",
  "komi": "Комі",
  "cornish": "Корніш",
  "kirghiz": "Киргизька",
  "latin": "Латинська",
  "luxembourgish": "Люксембурзька",
  "ganda": "Ганда",
  "limburgan": "Лімбургська",
  "lingala": "Лінгала",
  "lao": "Лаоська",
  "lithuanian": "Литовська",
  "luba_katanga": "Луба-катанга",
  "latvian": "Латвійська",
  "malagasy": "Малагасійська",
  "marshallese": "Маршалльська",
  "maori": "Маорі",
  "macedonian": "Македонська",
  "malayalam": "Малаялам",
  "mongolian": "Монгольська",
  "marathi": "Маратхі",
  "malay": "Малайська",
  "maltese": "Мальтійська",
  "burmese": "Бірманська",
  "norwegian_bokm_l": "Норвезька букмоль",
  "ndebele_north": "Ндебеле, північний",
  "nepali": "Непальська",
  "ndonga": "Ндонга",
  "dutch": "Голландська",
  "norwegian_nynorsk": "Норвезька нюннорск",
  "norwegian": "Норвезька",
  "south_ndebele": "Південний ндебеле",
  "navajo": "Навахо",
  "chichewa": "Чічева",
  "occitan": "Окситанська",
  "ojibwa": "Оджібва",
  "oromo": "Оромо",
  "oriya": "Орія",
  "ossetian": "Осетинська",
  "panjabi": "Панджабі",
  "pali": "Палі",
  "polish": "Польська",
  "pushto": "Пушту",
  "portuguese": "Португальська",
  "quechua": "Кечуа",
  "romansh": "Ретороманська",
  "rundi": "Рунді",
  "romanian": "Румунська",
  "russian": "Російська",
  "kinyarwanda": "Кіньяруанда",
  "sanskrit": "Санскрит",
  "sardinian": "Сардинська",
  "sindhi": "Сіндхі",
  "northern_sami": "Північний саамський",
  "sango": "Санго",
  "sinhala": "Сінгальська",
  "slovak": "Словацька",
  "slovenian": "Словенська",
  "samoan": "Самоанська",
  "shona": "Шона",
  "somali": "Сомалі",
  "albanian": "Албанська",
  "serbian": "Сербська",
  "swati": "Сваті",
  "sotho_southern": "Сото, південний",
  "sundanese": "Сунданська",
  "swedish": "Шведська",
  "swahili": "Суахілі",
  "tamil": "Тамільська",
  "telugu": "Телугу",
  "tajik": "Таджицька",
  "thai": "Тайська",
  "tigrinya": "Тігринья",
  "turkmen": "Туркменська",
  "tagalog": "Тагальська",
  "tswana": "Цвана",
  "tonga_tonga_islands_": "Тонга (острови Тонга)",
  "turkish": "Турецька",
  "tsonga": "Цонга",
  "tatar": "Татарська",
  "twi": "Тві",
  "tahitian": "Таїтянська",
  "uighur": "Уйгурська",
  "ukrainian": "Українська",
  "urdu": "Урду",
  "uzbek": "Узбецька",
  "venda": "Венда",
  "vietnamese": "В'єтнамська",
  "volap_k": "Волапюк",
  "walloon": "Валлонська",
  "wolof": "Волоф",
  "xhosa": "Коса",
  "yiddish": "Їдиш",
  "yoruba": "Йоруба",
  "zhuang": "Чжуанська",
  "chinese": "Китайська",
  "zulu": "Зулуська",
  "contact_mod": "Зв'язатися",
  "view_photo": "Переглянути фото",
  "upload_text": "Ви можете завантажити зображення у форматі JPG або PNG.",
  "photo_load_error": "Не вдалося завантажити зображення. Закрийте вікно й виберіть інший файл.",
  "photo_save_error": "Не вдалося зберегти фото. Спробуйте ще раз.",
  "uploading_photo": "Завантаження фото",
  "select_file": "Оберіть файл",
  "having_truble": "Якщо у вас виникли проблеми із завантаженням, спробуйте вибрати фотографію меншого розміру.",
  "choose_photo": "Виберіть місце для мініатюри. Вибрана вами мініатюра буде використовуватися у вашому профілі, приватних повідомленнях і візитках.",
  "save_changed": "Зберегти зміни",
  "remove_photo": "Видалити фото",
  "text_remove": "Ви впевнені, що хочете видалити фотографію свого профілю?  Якщо ви видалите фото, ваш профіль буде приховано від загального пошуку на платформі",
  "contacts_digital": "Контактів",
  "comment_modal_info": "Коментар як ви познайомились, про що домовились, опис контакту",
  "view_more": "Перегляд",
  "profile_photo_modal": "Фото профілю",
  "card_photo": "Фото візитки",
  "chart_photo": "Фото в чаті",
  "code_confirmation": "Код підтвердження буде надіслано на цю пошту.",
  "level_a": "Рівень A",
  "level_b": "Рівень B",
  "level_c": "Рівень C",
  "community_owner_check": "Власник спільноти",
  "page_verified": "Сторінка підтверджена",
  "contact_in_bank": "Цей контакт уже є у вашому Digital Bank. За необхідності ви можете оновити або змінити інформацію про нього.",
  "restore_to_bank": "Цей контакт раніше був у вашому Digital Bank. Ви можете відновити його, щоб знову мати доступ до керування контактом.",
  "count": "Ваш потенційний дохід тут",
  "edit_only": "Змінити",
  "select_direction": "Спочатку вкажіть Напрямок",
  "soon": "Скоро...",
  "A": "Рівень A",
  "B": "Рівень B",
  "C": "Рівень C",
  "selected": "Вибрано",
  "edit_contact_bank": "Ви успішно оновили контакт",
  "platform_language": "Мова платформи",
  "comment_modal_a": "A - Близькі контакти,",
  "comment_modal_b": "B - Регулярні,",
  "comment_modal_c": "C - Знайомі",
  "please_fill_field": "Будь ласка, заповніть всі обов'язкові поля",
  "empty_field": "Порожнє поле",
  "all_contacts": "Всі контакти",
  "edit_folder": "Ред.",
  "folders":"Папки",
  "create_folder": "Групуйте контакти в папки та легко перемикайтеся між ними",
  "my_folders": "Мої папки",
  "create_new_folder": "Створити нову папку",
  "delete_folder": "Видалити папку",
  "subtitle_delete":" Should I delete this folder?",
  "affect_contact": "Видалення папки не вплине на контакти, які знаходяться в ній.",
  "limit_folder": "Досягнуто ліміту створення папок",
  "new_folder": "Нова папка",
  "folder_name": "Назва папки",
  "selected_contacts": "Вибрані контакти",
  "add_contacts": "Додати контакти",
  "select_contact_show": "Оберіть контакти, які потрібно показати в цій папці.",
  "add_folder_name": "Ви повинні додати ім'я папки, щоб вибрати контакти",
  "must_add": "Ви повинні додати принаймні один контакт",
  "no_result": "Ваш запит не дав результатів",
  "congratulation": "Вітаємо!",
  "folder_success": "Папка успішно створена",
  "view_original_language": "Показати мовою оригіналу",
  "view_original": "Показати оригінал",
  "show_translation": "Показати переклад",
  "language_settings": "Налаштування мови",
  "check_spam": "Перевірте папку «Спам», якщо код не прийшов.",
  "card_not_a_connection": "Це картка іншого користувача, а не людина, з якою можна встановити зв'язок напряму. Отримайте до неї доступ на ринку карток, щоб додати її до свого Digital Bank."
}
